(function () {
  var A = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
  var PAL = {lave: [226, 92, 38], bleu: [38, 140, 200], violet: [140, 104, 226], emeraude: [40, 168, 130], or: [200, 152, 54], rouge: [214, 52, 52]};
  var P = new URLSearchParams(location.search), q = P.get('mx') || 'cycle', choco = P.get('bg') === 'choco', MOT = P.get('motion') || 'mix', drift = MOT === 'drift', waves = MOT === 'waves';
  var DUO = q === 'duo', CYC = q === 'cycle', OFF = parseFloat(P.get('off')) || 0, PER = (parseFloat(P.get('per')) || 36) * 1000;
  var HUES = DUO ? [PAL.bleu, PAL.lave] : [(CYC ? PAL.bleu.slice() : (PAL[q] || PAL.bleu))];
  var KEYS = [PAL.bleu, PAL.lave, PAL.violet];
  function cycleHue(t) {
    var u = (((t + OFF) / PER) % 1 + 1) % 1 * 3, i = Math.floor(u), f = u - i; f = f * f * (3 - 2 * f);
    var a = KEYS[i % 3], b = KEYS[(i + 1) % 3];
    for (var k = 0; k < 3; k++) HUES[0][k] = a[k] + (b[k] - a[k]) * f;
  }
  var LUM = parseFloat(P.get('lum')) || 0.5;
  var DARK = parseFloat(P.get('dark')) || 0.62;   // part de vide : 0.62 = environ 6 lettres sur 10 invisibles
  var BG = choco ? '#2b2019' : '#151515', BGC = choco ? [43, 32, 25] : [21, 21, 21], BASE = choco ? [58, 44, 35] : [32, 32, 32];
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  function ss(a, b, v) { var t = Math.max(0, Math.min(1, (v - a) / (b - a))); return t * t * (3 - 2 * t); }
  function make(sec, seed, lumK) {
    lumK = lumK || 1;
    sec.style.setProperty('background', BG, 'important'); sec.style.setProperty('--mxbg', BG);
    var cv = document.createElement('canvas');
    cv.className = 'dbt-mx'; cv.setAttribute('aria-hidden', 'true');
    sec.insertBefore(cv, sec.firstChild);
    var x = cv.getContext('2d'), fs = 13, cw = fs * 0.62, lh = fs * 1.35, cols, rows, W, H, chars = [], rects = [], dpr = Math.min(devicePixelRatio || 1, 2);
    var drops = [], nextDrop = 0, n = 0;
    // zones de texte : les lignes reelles du texte (Range), pour que le vide autour des mots reste serre.
    // Les diapos de carrousel masquees sont ignorees : seul le texte de la diapo affichee compte.
    function collect() {
      var sr = sec.getBoundingClientRect(); rects = [];
      [].forEach.call(sec.querySelectorAll('h1,h2,h3,p,li,.dbt-series,.dbt-soon,.dbt-btn'), function (e) {
        var sl = e.closest ? e.closest('.dbt-slide') : null;
        if (sl && !sl.classList.contains('is-on')) return;
        var list;
        if (e.matches('.dbt-soon,.dbt-btn')) list = [e.getBoundingClientRect()];
        else { var rg = document.createRange(); rg.selectNodeContents(e); list = [].slice.call(rg.getClientRects()); }
        list.forEach(function (r) { if (r.width > 0 && r.height > 0) rects.push([r.left - sr.left, r.top - sr.top, r.right - sr.left, r.bottom - sr.top]); });
      });
    }
    function size() {
      W = sec.clientWidth; H = sec.clientHeight;
      cv.width = W * dpr; cv.height = H * dpr; cv.style.width = W + 'px'; cv.style.height = H + 'px';
      x.setTransform(dpr, 0, 0, dpr, 0, 0);
      cols = Math.ceil(W / cw); rows = Math.ceil(H / lh); chars = [];
      for (var i = 0; i < cols * rows; i++) chars.push(A.charAt((Math.random() * A.length) | 0));
      x.font = fs + 'px Consolas,\'Courier New\',monospace'; x.textBaseline = 'top';
      collect();
    }
    sec.addEventListener('dbt:slide', collect);
    function mask(px, py) {
      var d = 1e9;
      for (var i = 0; i < rects.length; i++) { var r = rects[i], ex = Math.max(r[0] - px, 0, px - r[2]), ey = Math.max(r[1] - py, 0, py - r[3]); d = Math.min(d, Math.sqrt(ex * ex + ey * ey)); }
      var m = Math.min(1, d / 34); return m * m * (3 - 2 * m);
    }
    function fDrift(px, py, t) {
      var u = px / W, v = py / H;
      var a = Math.sin(u * 5.1 + t * 0.00011 + seed) + Math.sin(v * 7.3 - t * 0.00015 + u * 3 + seed * 2);
      var b = Math.sin((u * 2.3 + v * 3.1) * 3.2 + t * 0.00009 + seed * 3) + Math.sin(u * 11 - v * 5 + t * 0.00013);
      var s = (a + b) * 0.25 + 0.5, e = Math.min(u, 1 - u, 0.35) / 0.35;
      return Math.max(0, (s - 0.5) / 0.5) * (0.4 + 0.6 * e);
    }
    // plaques de lettres qui sortent du vide : champ lent a deux echelles, seuil haut = surtout du noir
    function vis0(px, py, t) {
      var u = px / W, v = py / H;
      var s1 = Math.sin(u * 3.1 + v * 1.7 + seed + t * 0.00004) + Math.sin(v * 4.3 - u * 2.2 + seed * 1.6 - t * 0.00005) + 0.6 * Math.sin((u + v) * 6.4 + seed * 2.3 + t * 0.00003);
      var s2 = Math.sin(u * 9.3 - v * 6.1 + seed * 3.1 + t * 0.00006) * Math.sin(v * 8.2 + u * 4.4 + seed * 0.7 - t * 0.00004);
      var s = s1 * 0.30 + s2 * 0.16 + 0.42;
      return ss(DARK, DARK + 0.3, s);
    }
    var SPEED = 68, WID = 40;
    function accum(px, py, t, out) {
      out[0] = 0; out[1] = 0;
      for (var i = 0; i < drops.length; i++) {
        var d = drops[i], a = (t - d.t0) / 1000;
        if (a < 0) continue;
        var dx = px - d.x, dy = py - d.y, dist = Math.sqrt(dx * dx + dy * dy), R = a * SPEED, wd = WID;
        if (d.quick) {
          // vague de clic : anneaux plus fins et un peu deformes (rayon qui varie avec l'angle, lentement)
          var ag = Math.atan2(dy, dx);
          dist /= 1 + 0.07 * (Math.sin(ag * 3 + d.p[0] + a * 0.5) + 0.7 * Math.sin(ag * 5 + d.p[1] - a * 0.4) + 0.5 * Math.sin(ag * 9 + d.p[2] + a * 0.3));
          wd = WID * 0.62;
        }
        var fadeIn = d.quick ? ss(0, 0.45, a) : ss(0, 2.2, a), env = d.amp * fadeIn * Math.exp(-a / 8.5) / (1 + R / 700);
        var w = Math.exp(-Math.pow((dist - R) / wd, 2)) + 0.6 * Math.exp(-Math.pow((dist - R * 0.72) / (wd * 1.05), 2)) + 0.36 * Math.exp(-Math.pow((dist - R * 0.46) / (wd * 1.1), 2)) + 0.2 * Math.exp(-Math.pow((dist - R * 0.24) / (wd * 1.2), 2));
        out[d.h] += env * w;
      }
    }
    // quick : la vague d'un clic apparait tout de suite (meme ton et meme energie que les vagues naturelles)
    function addDrop(t, px, py, amp, quick) { n++; drops.push({x: px, y: py, t0: t, amp: amp || 1, h: DUO ? (n % 2) : 0, quick: !!quick, p: [Math.random() * 6.28, Math.random() * 6.28, Math.random() * 6.28]}); if (drops.length > 8) drops.shift(); }
    var acc = [0, 0];
    function draw(t) {
      x.clearRect(0, 0, W, H);
      if (CYC) cycleHue(t);
      for (var r = 0; r < rows; r++) for (var c = 0; c < cols; c++) {
        var px = c * cw, py = r * lh, m = mask(px, py), vz = vis0(px, py, t) * (0.35 + 0.65 * m);
        var rr = BGC[0] + (BASE[0] - BGC[0]) * vz, gg = BGC[1] + (BASE[1] - BGC[1]) * vz, bb = BGC[2] + (BASE[2] - BGC[2]) * vz;
        if (drift) { var k = Math.max(0, fDrift(px, py, t) - 0.35) * m, e0 = ss(0.05, 0.6, k) * LUM * lumK, H0 = HUES[0]; rr += (H0[0] - rr) * e0; gg += (H0[1] - gg) * e0; bb += (H0[2] - bb) * e0; }
        else {
          accum(px, py, t, acc);
          if (!waves) acc[0] += Math.max(0, fDrift(px, py, t) - 0.45) * 0.9;
          for (var h = 0; h < HUES.length; h++) { var e = ss(0.12, 0.95, acc[h] * m) * LUM * lumK, Hc = HUES[h]; rr += (Hc[0] - rr) * e; gg += (Hc[1] - gg) * e; bb += (Hc[2] - bb) * e; }
        }
        x.fillStyle = 'rgb(' + (rr | 0) + ',' + (gg | 0) + ',' + (bb | 0) + ')'; x.fillText(chars[r * cols + c], px, py);
      }
    }
    var last = 0, vis = true;
    function tick(t) {
      if (!drift && t > nextDrop) { addDrop(t, W * (0.1 + 0.8 * Math.random()), H * (0.1 + 0.8 * Math.random()), 0.9 + 0.3 * Math.random()); nextDrop = t + 4200 + Math.random() * 3600; }
      while (drops.length && t - drops[0].t0 > 26000) drops.shift();
    }
    function loop(t) { if (vis && t - last > 60) { last = t; tick(t); draw(t); } requestAnimationFrame(loop); }
    size();
    if (drift) draw(0); else { addDrop(-3500, W * 0.62, H * 0.5, 1); addDrop(-9500, W * 0.28, H * 0.4, 1); draw(0); }
    if (!reduce) requestAnimationFrame(loop);
    if (!drift) {
      var lastMove = 0;
      sec.addEventListener('pointerdown', function (e) { var b = sec.getBoundingClientRect(); addDrop(performance.now(), e.clientX - b.left, e.clientY - b.top, 1.1, true); });
      sec.addEventListener('pointermove', function (e) { var nn = performance.now(); if (nn - lastMove > 2500 && e.pointerType === 'mouse') { lastMove = nn; var b = sec.getBoundingClientRect(); addDrop(nn, e.clientX - b.left, e.clientY - b.top, 0.7); } });
    }
    if (window.IntersectionObserver) new IntersectionObserver(function (e) { vis = e[0].isIntersecting; }).observe(sec);
    var to; addEventListener('resize', function () { clearTimeout(to); to = setTimeout(function () { size(); draw(performance.now()); }, 200); });
    // 23/10 : la scene commune change de hauteur quand une image ou une diapo se charge ou qu'une vague s'ajoute : on recale le canevas
    if (window.ResizeObserver) { var rt; new ResizeObserver(function () { clearTimeout(rt); rt = setTimeout(function () { if (sec.clientWidth !== W || sec.clientHeight !== H) { size(); draw(performance.now()); } }, 150); }).observe(sec); }
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { size(); });
  }
  function init() {
    // 23/10 : .dbt-stage = une seule matrice pour la boite et toutes les vagues (les sections dedans n'ont plus la leur)
    var stage = document.querySelector('.dbt-stage');
    // 26/10 : hors accueil (pas de .dbt-intro ni #pandora), le pied de page n'a plus sa propre matrice : c'est la matrice fixe de la page (.dbt-mxpage) qui passe derriere, la meme partout
    var home = !!document.querySelector('.dbt-intro, #pandora');
    [].forEach.call(document.querySelectorAll(home ? '.dbt-intro, #pandora, .dbt-foot' : '.dbt-intro, #pandora'), function (s, i) { if (stage && stage.contains(s)) return; make(s, 1.7 + i * 2.9); });
    if (stage) make(stage, 1.7);
    if (!document.querySelector('.dbt-intro, #pandora')) {
      var d = document.createElement('div'); d.className = 'dbt-mxpage'; d.setAttribute('aria-hidden', 'true');
      document.body.insertBefore(d, document.body.firstChild); make(d, 4.2, 0.3);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
